import ReusableDataTable from "../../hooks/ReusableDataTable";
import { Button, Label, Modal, TextInput, Select } from "flowbite-react";
// import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import '../../style/model.css';
import { FaPen } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import useInputValidation from "../../hooks/useInputValidation";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import axios from "axios";
import { useSidebar } from "../../context/SidebarOpenContext";
function Fabric() {
    // const navigate = useNavigate();
    const [AddModal, setAddModal] = useState(false);
    const [EditModal, setEditModal] = useState(false);
    const [DeleteModal, setDeleteModal] = useState(false);
    const [Input, setInput] = useState({});
    const [RawMaterial, setRawMaterial] = useState({});
    const [VendorData, setVendor] = useState([]);
    const { errors, handleChange, resetErrors } = useInputValidation();
    const { isSidebarOpen } = useSidebar();
    useEffect(() => {
        fetchVendor();
        fetchRawMaterial();
    }, []);


    const onChangeValue = (e) => {
        handleChange(e);
        setInput({ ...Input, [e.target.name]: e.target.value });
    }

    const fetchRawMaterial = async () => {
        try {
            const response = await axios.get("master/fabrics");
            const RawMaterialData = response.data;
            setRawMaterial(RawMaterialData);
        } catch (error) {
            console.error("Error fetching Fabrics data:", error);
        }
    };

    const fetchVendor = async () => {
        try {
            const response = await axios.get("master/vendors");
            const VendorData = response.data;
            console.log(VendorData);
            // const Vendor
            setVendor(VendorData);
        } catch (error) {
            console.error("Error fetching Vendor data:", error);
        }
    };
    // console.log(VendorData);
    // console.log(VendorData.vendor_name);

    const addRawMaterial = async (event) => {
    event.preventDefault();

    try {
        const res = await axios.post(
            `master/fabrics`,
            {
                fabric_content: Input.fabric_content,
                finish: Input.finish,
                length: Input.length,
                width: Input.width,
                gsm: Input.gsm,
                shade_no: Input.shade_no,
                roll_no: Input.roll_no,
                colour: Input.colour,
                count: Input.count,
                vendor: Input.vendor,
            },
            {
                validateStatus: () => true, // IMPORTANT FIX
            }
        );

        const { success, message } = res.data;

        if (success === 1) {
            Swal.fire({
                icon: "success",
                text: "Fabric Created Successfully",
                timer: 2000,
                showConfirmButton: false,
            });

            setAddModal(false);
            fetchRawMaterial();
        }

        else if (success === 2) {
            Swal.fire({
                icon: "warning",
                title: "Duplicate Roll No",
                text: message || "Fabric already exists",
                timer: 2500,
                showConfirmButton: true,
            });
        }

        else {
            Swal.fire({
                icon: "error",
                title: "Server Error",
                text: message || "Something went wrong. Please try again.",
                timer: 2500,
                showConfirmButton: true,
            });
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            title: "Unexpected Error",
            text: "Unable to create fabric. Please try again.",
        });
    }
};


    const UpdateRawMaterial = async (event) => {
    event.preventDefault();

    try {
        const res = await axios.put(
            `master/fabrics/${Input.id}`,
            {
                fabric_content: Input.fabric_content,
                finish: Input.finish,
                length: Input.length,
                width: Input.width,
                gsm: Input.gsm,
                shade_no: Input.shade_no,
                roll_no: Input.roll_no,
                colour: Input.colour,
                count: Input.count,
                vendor: Input.vendor,
            },
            {
                validateStatus: () => true, // IMPORTANT: allow 409, 400, etc.
            }
        );

        const { success, message } = res.data;

        if (success === 1) {
            Swal.fire({
                icon: "success",
                text: "Fabric details updated successfully!",
                timer: 2000,
                showConfirmButton: false,
            });
            setEditModal(false);
            fetchRawMaterial();
        }

        else if (success === 2) {
            Swal.fire({
                icon: "warning",
                title: "Duplicate Roll Number",
                text: message || "Roll number already exists.",
                timer: 3000,
                confirmButtonColor: "#d33",
            });
        }

        else if (success === 3) {
            Swal.fire({
                icon: "warning",
                title: "Duplicate Fabric Content",
                timer: 3000,
                text: message || "Fabric content already exists.",
                confirmButtonColor: "#d33",
            });
        }

        else {
            Swal.fire({
                icon: "error",
                title: "Update Failed",
                timer: 3000,
                text: message || "Error. Please try again.",
                confirmButtonColor: "#d33",
            });
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            title: "Unexpected Error",
            timer: 3000,
            text: "Unable to update fabric. Try again.",
            confirmButtonColor: "#d33",
        });
    }
};



    const deletRawMaterial = async () => {
        try {
            axios.delete(`master/fabrics/${Input.id}`).then((res) => {
                if (res.data.success === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "fabrics  deleted",
                        type: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    fetchRawMaterial();
                    setDeleteModal(false);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: "Server Problem. Please Try Again...",
                        type: "error",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                }
                return;
            });
        } catch (error) {
            throw error;
        }
    };


    const data = Array.isArray(RawMaterial)
        ? RawMaterial.map((RM) => ({
            id: RM.fabric_id,
            fabric_content: RM.fabric_content,
            finish: RM.finish,
            length: RM.length,
            width: RM.width,
            gsm: RM.gsm,
            shade_no: RM.shade_no,
            roll_no: RM.roll_no,
            colour: RM.colour,
            count: RM.count,
            vendor: RM.vendor,

            option: (<div style={{ display: "flex" }}>
                <FaPen className="text-amber-400 text-xl" onClick={() => {
                    setEditModal(true); setInput({
                        id: RM.fabric_id,
                        fabric_content: RM.fabric_content,
                        finish: RM.finish,
                        length: RM.length,
                        width: RM.width,
                        gsm: RM.gsm,
                        shade_no: RM.shade_no,
                        roll_no: RM.roll_no,
                        colour: RM.colour,
                        count: RM.count,
                        vendor: RM.vendor,
                    });
                }} />
                <MdDeleteForever className="ml-2 text-red-500 text-2xl" onClick={() => { setDeleteModal(true); setInput({ id: RM.fabric_id }) }} />
            </div>)
        }))
        : [];

    const columns = [
        { name: "S.No", selector: (row, index) => index + 1, sortable: true },
        { name: "Fabric Content", selector: (row) => row.fabric_content, sortable: true },
        { name: "Finish", selector: (row) => row.finish, sortable: true },
        { name: "Length", selector: (row) => row.length, sortable: true },
        { name: "Width", selector: (row) => row.width, sortable: true },
        { name: "GSM", selector: (row) => row.gsm, sortable: true },
        { name: "Shade No", selector: (row) => row.shade_no, sortable: true },
        { name: "Roll No", selector: (row) => row.roll_no, sortable: true },
        { name: "Colour", selector: (row) => row.colour, sortable: true },
        { name: "Count", selector: (row) => row.count, sortable: true },
        { name: "Vendor", selector: (row) => row.vendor, sortable: true },
        // { name: "Status", selector: (row) => row.status,
        //     cell: row => (
        //         <Badge color={row.status == "active" ? "success":"failure"}>{row.status}</Badge>
        //   ),  sortable: true },
        { name: "Option", selector: (row) => row.option },
    ];

    return (
        <div className={` ${isSidebarOpen ? "p-4 sm:ml-64 bg-content-bg min-h-screen " : "p-4  bg-content-bg min-h-screen"}  `} >

            <div className="p-4 rounded-lg dark:border-gray-700  mt-14">
                <div className="p-4 rounded-lg shadow bg-white">
                    <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" onClick={() => setAddModal(true)} >Add Fabrics</Button>
                    <ReusableDataTable
                        title="Fabrics List"
                        columns={columns}
                        data={data}
                    />
                </div>
            </div>

            <Modal
                show={AddModal}
                // size="md"
                onClose={() => {
                    setAddModal(false);
                    resetErrors();
                }}
                popup
            >
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Add Fabric</h3>
                        <form onSubmit={addRawMaterial} className="grid grid-cols-2 sm:grid-cols-2 gap-4">
                            {/* Fabric Content */}
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="fabric_content" value="Fabric Content" color={errors.fabric_content && "failure"} />
                                </div>
                                <TextInput
                                    name="fabric_content"
                                    id="fabric_content"
                                    required
                                    onChange={onChangeValue}
                                    color={errors.fabric_content && "failure"}
                                    helperText={
                                        errors.fabric_content && (
                                            <>
                                                <span className="font-medium"></span> {errors.fabric_content}
                                            </>
                                        )
                                    }
                                />

                            </div>

                            {/* Finish */}
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="finish" value="Finish" color={errors.finish && "failure"} />
                                </div>
                                <TextInput
                                    id="finish"
                                    name="finish"
                                    type="text"
                                    onChange={onChangeValue}
                                    color={errors.finish && "failure"}
                                    helperText={
                                        errors.finish && (
                                            <>
                                                <span className="font-medium"></span> {errors.finish}
                                            </>
                                        )
                                    }
                                    required
                                />
                            </div>

                            {/* Length */}
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="length" value="Length" color={errors.length && "failure"} />
                                </div>
                                <TextInput
                                    id="length"
                                    name="length"
                                    type="text"
                                    onChange={onChangeValue}
                                    color={errors.length && "failure"}
                                    helperText={
                                        errors.length && (
                                            <>
                                                <span className="font-medium"></span> {errors.length}
                                            </>
                                        )
                                    }
                                    required
                                />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="width" value="Width" color={errors.width && "failure"} />
                                </div>
                                <TextInput
                                    id="width"
                                    name="width"
                                    type="text"
                                    onChange={onChangeValue}
                                    color={errors.width && "failure"}
                                    helperText={
                                        errors.width && (
                                            <>
                                                <span className="font-medium"></span> {errors.width}
                                            </>
                                        )
                                    }
                                    required
                                />
                            </div>
                            {/* GSM */}
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="gsm" value="GSM" color={errors.gsm && "failure"} />
                                </div>
                                <TextInput
                                    id="gsm"
                                    name="gsm"
                                    type="number"
                                    onChange={onChangeValue}
                                    color={errors.gsm && "failure"}
                                    helperText={
                                        errors.gsm && (
                                            <>
                                                <span className="font-medium"></span> {errors.gsm}
                                            </>
                                        )
                                    }
                                    required
                                />
                            </div>

                            {/* Shade No */}
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="shade_no" value="Shade No" color={errors.shade_no && "failure"} />
                                </div>
                                <TextInput
                                    id="shade_no"
                                    name="shade_no"
                                    type="text"
                                    onChange={onChangeValue}
                                    color={errors.shade_no && "failure"}
                                    helperText={
                                        errors.shade_no && (
                                            <>
                                                <span className="font-medium"></span> {errors.shade_no}
                                            </>
                                        )
                                    }
                                    required
                                />
                            </div>

                            {/* Roll No */}
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="roll_no" value="Roll No" color={errors.roll_no && "failure"} />
                                </div>
                                <TextInput
                                    id="roll_no"
                                    name="roll_no"
                                    type="text"
                                    onChange={onChangeValue}
                                    color={errors.roll_no && "failure"}
                                    helperText={
                                        errors.roll_no && (
                                            <>
                                                <span className="font-medium"></span> {errors.roll_no}
                                            </>
                                        )
                                    }
                                    required
                                />
                            </div>

                            {/* Colour */}
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="colour" value="Colour" color={errors.colour && "failure"} />
                                </div>
                                <TextInput
                                    id="colour"
                                    name="colour"
                                    type="text"
                                    onChange={onChangeValue}
                                    color={errors.colour && "failure"}
                                    helperText={
                                        errors.colour && (
                                            <>
                                                <span className="font-medium"></span> {errors.colour}
                                            </>
                                        )
                                    }
                                    required
                                />
                            </div>

                            {/* Count */}
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="count" value="Count" color={errors.count && "failure"} />
                                </div>
                                <TextInput
                                    id="count"
                                    name="count"
                                    type="text"
                                    onChange={onChangeValue}
                                    color={errors.count && "failure"}
                                    helperText={
                                        errors.count && (
                                            <>
                                                <span className="font-medium"></span> {errors.count}
                                            </>
                                        )
                                    }
                                    required
                                />
                            </div>

                            {/* Vendor */}
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="vendor" value="Vendor" />
                                </div>
                                <Select
                                    id="vendor"
                                    name="vendor"
                                    required
                                    onChange={onChangeValue}
                                >
                                    <option value="">Select Vendor</option>
                                    {VendorData.map((item) => (
                                        <option key={item.vendor_id} value={item.vendor_name}>
                                            {item.vendor_name}
                                        </option>
                                    ))}
                                </Select>
                            </div>

                            {/* Status */}
                            <div>
                                {/* <div className="pt-2 mb-2 block">
                        <Label htmlFor="status" value="Status" />
                    </div>
                    <Select id="status" name="status" onChange={onChangeValue} required>
                        <option value="">Select an option</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                    </Select> */}
                            </div>

                            {/* Submit & Cancel Buttons */}
                            <div className="pt-2 w-full flex justify-center ml-12">
                                <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" type="submit">
                                    Submit
                                </Button>
                                <Button className="ml-2" color="gray" onClick={() => { setAddModal(false); resetErrors(); }}>
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>



            <Modal
                show={EditModal}
                // size="md"
                onClose={() => {
                    setEditModal(false);
                    resetErrors();
                }}
                popup
            >
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Update Fabric Details</h3>
                        <form onSubmit={UpdateRawMaterial} className="grid grid-cols-2 sm:grid-cols-2 gap-4">
                            {/* Fabric Content */}
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="fabric_content" value="Fabric Content" color={errors.fabric_content && "failure"} />
                                </div>
                                <TextInput
                                    name="fabric_content"
                                    id="fabric_content"
                                    placeholder="Enter fabric content"
                                    type="text"
                                    required
                                    onChange={onChangeValue}
                                    color={errors.fabric_content && "failure"}
                                    value={Input.fabric_content}
                                    helperText={
                                        errors.fabric_content && (
                                            <>
                                                <span className="font-medium"></span> {errors.fabric_content}
                                            </>
                                        )
                                    }
                                />
                            </div>

                            {/* Finish */}
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="finish" value="Finish (Stock)" color={errors.finish && "failure"} />
                                </div>
                                <TextInput
                                    id="finish"
                                    name="finish"
                                    type="text"
                                    // min={1}
                                    // step="0.001"
                                    required
                                    onChange={onChangeValue}
                                    color={errors.finish && "failure"}
                                    value={Input.finish}
                                    helperText={
                                        errors.finish && (
                                            <>
                                                <span className="font-medium"></span> {errors.finish}
                                            </>
                                        )
                                    }
                                />
                            </div>

                            {/* Length */}
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="length" value="Length" color={errors.length && "failure"} />
                                </div>
                                <TextInput
                                    id="length"
                                    name="length"
                                    type="number"
                                    required
                                    onChange={onChangeValue}
                                    color={errors.length && "failure"}
                                    value={Input.length}
                                    helperText={
                                        errors.length && (
                                            <>
                                                <span className="font-medium"></span> {errors.length}
                                            </>
                                        )
                                    }
                                />
                            </div>
                            {/* Width */}
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="width" value="Width" color={errors.width && "failure"} />
                                </div>
                                <TextInput
                                    id="width"
                                    name="width"
                                    type="number"
                                    required
                                    onChange={onChangeValue}
                                    color={errors.width && "failure"}
                                    value={Input.width}
                                    helperText={
                                        errors.width && (
                                            <>
                                                <span className="font-medium"></span> {errors.width}
                                            </>
                                        )
                                    }
                                />
                            </div>

                            {/* GSM */}
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="gsm" value="GSM" color={errors.gsm && "failure"} />
                                </div>
                                <TextInput
                                    id="gsm"
                                    name="gsm"
                                    type="number"
                                    required
                                    onChange={onChangeValue}
                                    color={errors.gsm && "failure"}
                                    value={Input.gsm}
                                    helperText={
                                        errors.gsm && (
                                            <>
                                                <span className="font-medium"></span> {errors.gsm}
                                            </>
                                        )
                                    }
                                />
                            </div>

                            {/* Shade No */}
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="shade_no" value="Shade No" color={errors.shade_no && "failure"} />
                                </div>
                                <TextInput
                                    id="shade_no"
                                    name="shade_no"
                                    type="text"
                                    required
                                    onChange={onChangeValue}
                                    color={errors.shade_no && "failure"}
                                    value={Input.shade_no}
                                    helperText={
                                        errors.shade_no && (
                                            <>
                                                <span className="font-medium"></span> {errors.shade_no}
                                            </>
                                        )
                                    }
                                />
                            </div>

                            {/* Roll No */}
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="roll_no" value="Roll No" color={errors.roll_no && "failure"} />
                                </div>
                                <TextInput
                                    id="roll_no"
                                    name="roll_no"
                                    type="text"
                                    required
                                    onChange={onChangeValue}
                                    color={errors.roll_no && "failure"}
                                    value={Input.roll_no}
                                    helperText={
                                        errors.roll_no && (
                                            <>
                                                <span className="font-medium"></span> {errors.roll_no}
                                            </>
                                        )
                                    }
                                />
                            </div>

                            {/* Colour */}
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="colour" value="Colour" color={errors.colour && "failure"} />
                                </div>
                                <TextInput
                                    id="colour"
                                    name="colour"
                                    type="text"
                                    required
                                    onChange={onChangeValue}
                                    color={errors.colour && "failure"}
                                    value={Input.colour}
                                    helperText={
                                        errors.colour && (
                                            <>
                                                <span className="font-medium"></span> {errors.colour}
                                            </>
                                        )
                                    }
                                />
                            </div>

                            {/* Count */}
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="count" value="Count" color={errors.count && "failure"} />
                                </div>
                                <TextInput
                                    id="count"
                                    name="count"
                                    type="text"
                                    required
                                    onChange={onChangeValue}
                                    color={errors.count && "failure"}
                                    value={Input.count}
                                    helperText={
                                        errors.count && (
                                            <>
                                                <span className="font-medium"></span> {errors.count}
                                            </>
                                        )
                                    }
                                />
                            </div>

                            {/* Vendor */}
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="vendor" value="Vendor" />
                                </div>
                                <Select
                                    id="vendor"
                                    name="vendor"
                                    onChange={onChangeValue}
                                    value={Input.vendor}
                                    required
                                >
                                    <option value="">Select Vendor</option>
                                    {VendorData.map((item) => (
                                        <option key={item.vendor_id} value={item.vendor_name}>
                                            {item.vendor_name}
                                        </option>
                                    ))}
                                </Select>
                            </div>

                            {/* Status */}
                            <div>
                                {/* <div className="pt-2 mb-2 block">
                                    <Label htmlFor="status" value="Status" />
                                </div>
                                <Select
                                    id="status"
                                    name="status"
                                    onChange={onChangeValue}
                                    value={Input.status}
                                    required
                                >
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </Select> */}
                            </div>

                            {/* Submit & Cancel Buttons */}
                            <div className="pt-2 w-full flex justify-center ml-12">
                                <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" type="submit">
                                    Submit
                                </Button>
                                <Button className="ml-2" color="gray" onClick={() => { setEditModal(false); resetErrors(); }}>
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>


            <Modal show={DeleteModal} size="md" onClose={() => setDeleteModal(false)} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="text-center">
                        <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                            Are you sure you want to delete this Fabric?
                        </h3>
                        <div className="flex justify-center gap-4">
                            <Button color="failure" onClick={() => deletRawMaterial()}>
                                {"Yes"}
                            </Button>
                            <Button color="gray" onClick={() => setDeleteModal(false)}>
                                No
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </div>


    );
}

export default Fabric;
